import React from 'react'
import { VerificationUserFormStep } from './VerificationUserFormStep'
import { useVerifyUserMutation } from './Verification.codegen'
import { notification } from '../../../components/common/notifications/Notifications'
import { t } from '@lingui/macro'
import { LoginContextUserType, useLoginContext } from '../login/LoginContext'
import { observer } from 'mobx-react'
import { AskAdditionalDataAndPasswordStep } from '../additional-info/AskAdditionalDataAndPasswordStep'

type VerifyUserFormStepProps = {
  // pass
}

const useFetchUserData = () => {
  const ctx = useLoginContext()

  const [fetch] = useVerifyUserMutation()

  return async () => {
    const { data } = await fetch({
      variables: {
        accountName: ctx.userIdentity,
        input: ctx.verificationData!
      }
    })
    const userByVerificationData =
      data?.organisation?.userByVerificationData ?? null

    if (!userByVerificationData) {
      notification.warning(t`Verification fields are incorrect`)
      return false
    }

    ctx.setUserData(userByVerificationData as Partial<LoginContextUserType>)
    return true
  }
}

export const VerifyUserFormStep: React.FC<VerifyUserFormStepProps> = observer(
  () => {
    const fetchUserData = useFetchUserData()
    const ctx = useLoginContext()

    const submit = async () => {
      if (await fetchUserData()) {
        ctx.setStepView(AskAdditionalDataAndPasswordStep)
      }
    }

    return <VerificationUserFormStep submit={submit} />
  }
)

VerifyUserFormStep.displayName = 'VerifyUserFormStep'
